<template>
  <div id="contribute" v-loading="loading" element-loading-text="正在处理请求请稍候">
    <!-- 投稿 -->
    <el-form :model="registerData" :rules="rules" ref="registerData" label-position="left">
      <el-form-item label="文档名称" prop="documentName">
        <el-input  maxlength="30"   show-word-limit placeholder="请输入文档名称" v-model="registerData.documentName" clearable></el-input>
      </el-form-item>
      <el-form-item label="文档类型" prop="documentType">
        <el-select v-model="registerData.documentType" filterable placeholder="文档类型" clearable>
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上传文档" prop="documentPath">
        <el-upload class="upload-demo" :action="`${baseUrl}/article/document/uploadDocumentFile`"
                   :headers="headerObj"
                   :on-error="onError"
                   :on-success="handleSuccess" multiple :before-upload="beforeUpload" :limit="1"
                   :on-exceed="handleExceed" :file-list="fileList" :disabled="disabled">
          <el-button type="primary" plain>上传文档</el-button>
          <div class="el-upload__tip" slot="tip">限制单次上传1个文件，大小在500M以内。</div>
        </el-upload>
      </el-form-item>

<!--      <el-form-item label="是否公开" prop="shareSwitch">-->
<!--        <el-radio-group v-model="registerData.shareSwitch">-->
<!--          <el-radio label="ON">是</el-radio>-->
<!--          <el-radio label="OFF">否</el-radio>-->
<!--        </el-radio-group>-->
<!--      </el-form-item>-->
      <!--			<el-form-item label="投稿领域" prop="areaId">-->
      <!--				<el-checkbox-group v-model="registerData.areaId" :max="1">-->
      <!--					<el-checkbox :label="item.id" v-for="item in Aarealist"-->
      <!--						:key="item.id">{{item.areaName}}</el-checkbox>-->
      <!--				</el-checkbox-group>-->
      <!--			</el-form-item>-->

      <!--      下面是自定义表单-->
      <div v-for="(item, index) in formConfig" :key="index">
        <!-- 输入框 -->
        <el-form-item
            v-if="item.type === 'input'"
            :label="item.label"
            :prop="item.key"
        >
          <el-input
              v-model="registerData[item.key]"
              :placeholder="`请输入${item.label}`"
          />
        </el-form-item>

        <!-- 单选框 -->
        <el-form-item
            v-if="item.type === 'radio'"
            :label="item.label"
            :prop="item.key"
        >
          <el-radio-group v-model="registerData[item.key]">
            <el-radio
                v-for="(option, oIndex) in item.options"
                :key="oIndex"
                :label="option.label"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 多选框 -->
        <el-form-item
            v-if="item.type === 'checkbox'"
            :label="item.label"
            :prop="item.key"
        >
          <el-checkbox-group v-model="registerData[item.key]">
            <el-checkbox
                v-for="(coption, ocIndex) in item.options "
                :key="ocIndex"
                :label="coption.label"
            >
              {{ coption.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>


      <el-form-item class="checked">
        <el-checkbox v-model="checked"></el-checkbox>
        <a @click="showStatement = true">作品原创及授权声明</a>
      </el-form-item>

      <el-form-item class="checked" style="margin-top: -30px">
        <el-checkbox v-model="checkedShow"></el-checkbox>
        <div style="margin-left: 6px" >同意将本作品列为平台优秀作品进行展示</div>
      </el-form-item>

      <el-form-item class="options">
        <!-- <el-button class="reset" @click="resetForm('registerData')">重置</el-button> -->
        <el-button class="submit" @click="submitForm('registerData')" :disabled="disabled">提交</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="作品原创与授权声明" :visible.sync="showStatement" v-if="showStatement" width="900px" center
               custom-class="Statement" :append-to-body="true">
      <div class="info" v-html="projectInfo.statement">
<!--        <h2></h2>-->

<!--        <p>-->
<!--          为了保护版权人的合法权益，根据《中华人民共和国著作权法》等法律规定，“万木智普”&#45;&#45;科普征文系统（以下简称“万木智普”）活动平台做如下版权声明:</p>-->
<!--        <p>-->
<!--          1.应征者自向发起方投稿之日起，即一次性、不可撤销地将其在世界范围内对其投稿作品所拥有的著作权及其对投稿作品一切图像的表现物的全部权利（包括内容原创申请权、商标申请权等），以及与此相关的全部衍生权利，在法律许可的方式和途径下，全部无偿、自动、永久转让给发起方；应征人承诺在法律允许的范围内授权发起方（包括发起方认可的第三方）在全世界范围内永久地行使与该投稿作品相关的著作人身权。发起方亦可将授让的权利再次转让给任何第三人。-->
<!--        </p>-->
<!--        <p>-->
<!--          2.所有投稿的作品（包括初次提交、后续修改、补充、深化或撤回后再提交等任何情形、任何时段提交的任何方案，包括但不限于应征作品中包括的信息、文本、图像、链接、字幕或组成部分）应具有原创性，应征者保证其投稿作品及发起方使用该作品均不存在任何侵权、违约、以及其他任何违法或不当情形。若存在上述情形，发起方将取消其项目参与资格，如已发放证书，发起方有权全部追回，所有法律责任由应征者本人承担。请注意：若中选的投稿作品无法申请知识产权，同样视为无效作品，发起方有权追回所有证书及荣誉，产生任何不良影响，发起方有权要求该应征人赔偿。-->
<!--        </p>-->
<!--        <p>-->
<!--          3.所有投稿作品的知识产权归发起方所有(包括初次提交、后续修改、补充、深化或撤回后再提交等任何情形、任何时段提交的任何方案，包括但不限于著作权，对作品的一切平面、立体或电子载体的全部权利)，发起方有权永久使用被采用的作品，并进行任何形式的使用、开发、修改、授权、许可或保护等活动。发起方拥有对其作品不完善之处进行修改的权利，拥有决定设计方案使用场合、使用方式、使用时间的权利。-->
<!--        </p>-->
<!--        <p>-->
<!--          4.应征者除根据本征集公告获得相应奖励和荣誉外，不再获得其他费用。对本征集公告及其附件产生的任何疑义，发起方保留最终解释权。任何与本次征集有关的未尽事宜，均由发起方进一步制定相应规定并进行解释</p>-->
<!--        <p>-->
<!--          5.如投稿作品相同或相似，以先应征者优先(以收到应征文件时间为先后次序)。所有应征文件恕不退稿，请应征者自留底稿。</p>-->
<!--        <p>6.应征者参与本次征集活动所发生的一切费用和支出，除与发起方有另行约定外，均由应征者自行承担。</p>-->
<!--        <p>7.-->
<!--          如应征者提交的作品或发起方对该作品的任何形式的使用导致发起方及由其授权的单位面临或遭受任何第三方的索赔、投诉/诉讼/仲裁等情形，或使发起方及由其授权的单位遭受任何名誉、声誉或经济上的直接或间接损失，无论应征者有无过错，应征者均应当按照发起方要求，采取足够而适当的措施以保证发起方对该设计方案的使用且免受上述任何影响。应征者应当自行承担由此产生的费用，并赔偿由此给发起方造成的全部损失（包括但不限于声誉损失、直接经济损失，发起方应当向第三方承担的损失）。-->
<!--        </p>-->
<!--        <p>8.自投稿日起，即视应征者同意以上法律声明，接受本规则的相关规定并同意放弃任何异议的权利。</p>-->

      </div>
      <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showStatement = false">确 定</el-button>
			</span>
    </el-dialog>
  </div>
</template>
<script>
import baseUrl from "@/request/config.js"
import {arealist, ProjectPage, saveOrUpdate} from '@/request/api.js';

export default {
  name: 'contribute',
  data() {
    return {
      showStatement: false,
      baseUrl: '',
      registerData: {
        documentName: "", // 文档名称
        documentType: "", // 文档类型
        documentPath: "", // 文档路径
        id: '',
        areaId: [], // 领域
        reviewDirections: [], // 评审方向
        shareSwitch:'OFF'
      },
      headerObj: {
        'Project-Id': localStorage.getItem('projectId'),
        'token': localStorage.getItem('headToken'),
        'id': this.$store.state.documentId
      },
      checked: false, // 授权声明
      checkedShow: false, // 授权声明
      Aarealist: [],
      directionList: [{
        name: '预防',
        index: 1
      },
        {
          name: '筛查',
          index: 2
        },
        {
          name: '诊断',
          index: 3
        },
        {
          name: '治疗',
          index: 4
        },
        {
          name: '康复',
          index: 5
        },
        {
          name: '人文关怀',
          index: 6
        }
      ],
      rules: {
        documentName: [{
          required: true,
          message: '请输入文档名称',
          trigger: 'blur'
        }, {
          min: 2,
          max: 100,
          message: '长度在 2 到 100 个字符',
          trigger: 'blur'
        }],
        documentType: [{
          required: true,
          message: '请选择文档类型',
          trigger: 'change|blur'
        }],
        documentPath: [{
          required: true,
          message: '请上传文档',
          trigger: 'change'
        }],
        shareSwitch: [
          { required: true, message: '请选择是否公开', trigger: 'change' }
        ],
        reviewDirections: [{
          required: true,
          message: '请选择文档评审方向',
          trigger: 'change'
        }],
        areaId: [{
          required: true,
          message: '请选择文档所属领域',
          trigger: 'change'
        }]
      },
      options: [{
        value: 'TEXT',
        label: '图文'
      }, {
        value: 'VEDIO',
        label: '视频'
      },],
      fileList: [],
      fileList2: [],

      loading: false,
      disabled: false,
      formConfig: [],
      projectInfo:{}
    }
  },
  created() {
    this.baseUrl = baseUrl;
    this.queryProject()
    // this.getarealist();
  },
  mounted() {
  },
  watch: {
    '$store.state.documentId': {
      handler(val) {
        // console.log(val, '2')
        this.registerData.id = val;
      },
      deep: true,
      immediate: true

    }
  },
  methods: {
    queryProject() {
      ProjectPage().then(res => {
        if (res.code == 200) {
          console.log(res.data.projectDocumentForm)
          this.projectInfo=res.data
          this.formConfig = JSON.parse(res.data.projectDocumentForm).map(item => {
            if (item.options && item.options.length > 0) {
              item.options = item.options.map(opt => ({
                value: opt.label, // 使用 label 作为 value（或自定义生成唯一值）
                label: opt.label
              }));
              this.$set(this.registerData, item.key, item.type === 'checkbox' ? [] : '')
            }
            return item;
          });
          this.initRules();

          // this.formConfig = JSON.parse(res.data.projectDocumentForm).map(item => {
          //   return {
          //     ...item,
          //     // 强制确保 options 是数组，即使原始数据中没有 options
          //     options: item.options ? item.options.map(opt => ({
          //       value: opt.label, // 或自定义唯一值
          //       label: opt.label
          //     })) : []
          //   };
          // });
          console.log("之后", this.formConfig);

        }
      }).catch(err => {
        console.log(err)
      })
    },


    // 获取领域列表
    getarealist() {
      arealist().then(res => {
        if (res.code == 200) {
          console.log(res)
          this.Aarealist = res.data
        }
      })
    },
    // 初始化 rules 校验规则
    initRules() {
      const rules = {};
      this.formConfig.forEach(item => {
        const fieldRules = [];
        // 必填项处理 item.required
        if (true) {
          const rule = {
            required: true,
            message: item.message || `${item.label}不能为空`,
            trigger: 'change' // 默认触发方式
          };

          // 根据字段类型设置 trigger 和 type
          if (item.type === 'input') {
            rule.trigger = 'blur';
          } else if (item.type === 'checkbox') {
            rule.type = 'array';
            rule.message = item.message || `请至少选择一个${item.label}`;
          }

          fieldRules.push(rule);
        }

        // 输入框支持 min/max 长度限制
        if (item.type === 'input' && item.required) {
          if (item.min || item.max) {
            fieldRules.push({
              min: item.min || undefined,
              max: item.max || undefined,
              message: item.lengthMessage || `长度在 ${item.min || 0} 到 ${item.max || 999} 个字符`,
              trigger: 'blur'
            });
          }
        }

        if (fieldRules.length > 0) {
          this.rules[item.key] = fieldRules;
        }
      });

      // this.rules = rules;
      console.log("规则", this.rules);
    },
    handleSuccess(res, file) {
      console.log(res)
      console.log(file);
      this.disabled = false;

      if (res.code != 200) {
        this.$notify({
          title: '提示',
          message: res.msg,
          type: 'error',
          position: 'bottom-right'
        });
        return
      }


      this.registerData.documentPath = res.data;
      if (!this.registerData.documentName) {
        let str = file.name.split('.');
        str.pop();
        str = str.join('')
        this.registerData.documentName = str;
      }
      let type = file.raw.type.split("/")[0];
      if (type == 'video') {
        this.registerData.documentType = 'VEDIO';
      } else if (type == 'audio') {
        this.registerData.documentType = 'AUDIO';
      } else {
        this.registerData.documentType = 'TEXT';
      }
    },
    onError(err, file, fileList) {
      console.log(err)
      console.log(file)
      console.log(fileList)

    },

    beforeUpload() {
      this.disabled = true;
    },

    submitForm(formName) {
      if (this.checked) {
        this.$refs[formName].validate((valid, error) => {
          if (valid) {
            this.loading = true;
            const filteredData = this.filterByFormConfig(this.registerData, this.formConfig);
            const jsonString = JSON.stringify(filteredData);
            console.log(jsonString)
            this.registerData.documentFormData = jsonString;
            this.registerData.shareSwitch=this.checkedShow?'ON':'OFF';

            // console.log(this.registerData)
            // return
            saveOrUpdate(this.registerData).then(res => {
              if (res.code == 200) {
                this.resetForm('registerData');
                this.fileList = [];
                this.$emit('uploadSuccess', {
                  type: 'success',
                  login: true
                });
                this.$store.state.documentId = '';
                this.$notify({
                  title: '投稿成功',
                  message: `投稿成功`,
                  type: 'success',
                  position: 'bottom-right'
                });
                this.loading = false;
              } else {
                this.$notify({
                  title: '投稿失败',
                  message: `${res.msg}`,
                  type: 'error',
                  position: 'bottom-right'
                });
                this.loading = false;
              }
            }).catch(err => {
              console.log(err);
              this.resetForm('registerData');
            })
          } else {
            console.log(error);
            return false;
          }
        });
      } else {
        this.$notify({
          title: '提示',
          message: `请阅读并确认作品原创及授权声明`,
          type: 'error',
          position: 'bottom-right'
        });
      }

    },

    filterByFormConfig(data, formConfig) {
      // 1. 提取所有需要保留的 key
      const validKeys = new Set(formConfig.map(item => item.key));
      // 2. 过滤数据
      return Object.entries(data).reduce((acc, [key, value]) => {
        if (validKeys.has(key)) {
          acc[key] = value;
        }
        return acc;
      }, {});
    },

    handleExceed(files, fileList) {
      this.$notify({
        title: '提示',
        message: `只允许单个文件上传，如需修改上传的文件 请先删除列表中的文件。`,
        type: 'error',
        position: 'bottom-right'
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style lang="scss" scoped>
#contribute {
  ::v-deep .el-form {
    margin: 50px 50px 0;

    .el-form-item {
      display: flex;
      align-items: center;
      margin-bottom: 40px;

      .el-form-item__label {
        font-size: 20px;
        color: rgba(47, 52, 71, 1);
        width: 200px;
      }

      .el-form-item__content {
        flex: 1;
        margin: 0;
        display: flex;

        * {
          font-size: 16px;
        }

        .el-input {
          flex: 1;
          height: 80px;

          .el-input__inner {
            height: 100%;
          }

          .el-input-group__append {
            button {
              height: 100%;
            }
          }
        }

        .el-select {
          width: 100%;
        }

        .el-form-item__error {
          font-size: 14px;
          color: #F56C6C;
        }
      }
    }

    .checked {

      .el-form-item__content {

        display: flex;
        justify-content: center;
        align-items: center;

        a {
          margin-left: 6px;
          text-decoration: underline;
          line-height: 1.5;
        }
      }

      .el-form-item__error {
        width: 100%;
        text-align: center;
      }
    }

    .options .el-form-item__content {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-button {
        width: 180px;
        height: 80px;
      }

      .submit {
        background-color: #28B0A6;

        * {
          color: #fff;
        }
      }
    }
  }


}

::v-deep .Statement {
  p {
    margin-bottom: 10px;
    text-align: justify;
  }
}
</style>